import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=d06d1724&scoped=true"
import script from "./chart.vue?vue&type=script&lang=js"
export * from "./chart.vue?vue&type=script&lang=js"
import style0 from "./chart.vue?vue&type=style&index=0&id=d06d1724&prod&lang=scss&scoped=true"
import style1 from "./chart.vue?vue&type=style&index=1&id=d06d1724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06d1724",
  null
  
)

export default component.exports